/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Job_Matching_ContentInputs */

const en_help_job_matching_content = /** @type {(inputs: Help_Job_Matching_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our job matching engine aggregates listings from multiple sources across the DACH region. Set your search criteria and salary expectations to get personalized recommendations.`)
};

const de_help_job_matching_content = /** @type {(inputs: Help_Job_Matching_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Job-Matching-Engine sammelt Stellenangebote aus mehreren Quellen im DACH-Raum. Legen Sie Ihre Suchkriterien und Gehaltsvorstellungen fest.`)
};

const fr_help_job_matching_content = /** @type {(inputs: Help_Job_Matching_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notre moteur de matching collecte les offres de multiples sources dans la région DACH. Définissez vos critères de recherche et vos attentes salariales.`)
};

const es_help_job_matching_content = /** @type {(inputs: Help_Job_Matching_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestro motor de búsqueda reúne ofertas de múltiples fuentes en la región DACH. Defina sus criterios de búsqueda y expectativas salariales.`)
};

const it_help_job_matching_content = /** @type {(inputs: Help_Job_Matching_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il nostro motore raccoglie annunci da più fonti nella regione DACH. Imposta i tuoi criteri di ricerca e le aspettative salariali.`)
};

const nl_help_job_matching_content = /** @type {(inputs: Help_Job_Matching_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onze matching-engine verzamelt vacatures uit meerdere bronnen in de DACH-regio. Stel uw zoekcriteria en salarisverwachtingen in.`)
};

const pl_help_job_matching_content = /** @type {(inputs: Help_Job_Matching_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasz silnik zbiera oferty z wielu źródeł w regionie DACH. Ustaw kryteria wyszukiwania i oczekiwania płacowe.`)
};

const fi_help_job_matching_content = /** @type {(inputs: Help_Job_Matching_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikkahakumme kokoaa ilmoituksia useista lähteistä DACH-alueella. Aseta hakukriteerisi ja palkkaodotuksesi.`)
};

const da_help_job_matching_content = /** @type {(inputs: Help_Job_Matching_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vores job-matching-motor samler jobannoncer fra flere kilder i DACH-regionen. Indstil dine søgekriterier og lønforventninger.`)
};

const sv_help_job_matching_content = /** @type {(inputs: Help_Job_Matching_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vår jobbmatchningsmotor samlar annonser från flera källor i DACH-regionen. Ställ in dina sökkriterier och löneförväntningar.`)
};

/**
* | output |
* | --- |
* | "Our job matching engine aggregates listings from multiple sources across the DACH region. Set your search criteria and salary expectations to get personalize..." |
*
* @param {Help_Job_Matching_ContentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const help_job_matching_content = /** @type {((inputs?: Help_Job_Matching_ContentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Job_Matching_ContentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_help_job_matching_content(inputs)
	if (locale === "fr") return fr_help_job_matching_content(inputs)
	if (locale === "es") return es_help_job_matching_content(inputs)
	if (locale === "it") return it_help_job_matching_content(inputs)
	if (locale === "nl") return nl_help_job_matching_content(inputs)
	if (locale === "pl") return pl_help_job_matching_content(inputs)
	if (locale === "fi") return fi_help_job_matching_content(inputs)
	if (locale === "da") return da_help_job_matching_content(inputs)
	if (locale === "sv") return sv_help_job_matching_content(inputs)
	return en_help_job_matching_content(inputs)
});